export const SUBJECT_CATEGORY_CODES = ['PRIMARY', 'SECONDARY', 'BILINGUAL', 'TECHNICAL'];
export const DEFAULT_SUBJECT_CATEGORIES = ['PRIMARY', 'SECONDARY'];
//# sourceMappingURL=subject-categories.js.map